var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.933,
    height: 26.683,
    viewBox: "0 0 27.933 26.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2961",
    "data-name": "Group 2961",
    transform: "translate(-20086.87 -9537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4147",
    "data-name": "Path 4147",
    d: "M318.906,488.579h4.208a.264.264,0,0,0,.265-.265v-1.972a.264.264,0,0,0-.265-.265h-4.208a.264.264,0,0,0-.265.265v1.972A.264.264,0,0,0,318.906,488.579Z",
    transform: "translate(19780.537 9075.104)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4148",
    "data-name": "Path 4148",
    d: "M422.506,488.579h4.208a.264.264,0,0,0,.265-.265v-1.972a.264.264,0,0,0-.265-.265h-4.208a.264.264,0,0,0-.265.265v1.972A.263.263,0,0,0,422.506,488.579Z",
    transform: "translate(19682.379 9075.104)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4149",
    "data-name": "Path 4149",
    d: "M374.632,423.92h-4.208a.264.264,0,0,0-.265.265v1.972a.264.264,0,0,0,.265.265h4.208a.264.264,0,0,0,.265-.265v-1.972A.284.284,0,0,0,374.632,423.92Z",
    transform: "translate(19731.727 9133.996)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4150",
    "data-name": "Path 4150",
    d: "M474.5,426.983h4.208a.264.264,0,0,0,.265-.265v-1.972a.264.264,0,0,0-.265-.265H474.5a.264.264,0,0,0-.265.265v1.972C474.211,426.865,474.328,426.983,474.5,426.983Z",
    transform: "translate(19633.119 9133.463)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4151",
    "data-name": "Path 4151",
    d: "M323.112,362.88H318.9a.264.264,0,0,0-.265.265v1.972a.264.264,0,0,0,.265.265h4.208a.264.264,0,0,0,.265-.265v-1.972A.264.264,0,0,0,323.112,362.88Z",
    transform: "translate(19780.539 9191.829)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4152",
    "data-name": "Path 4152",
    d: "M422.506,365.379h4.208a.264.264,0,0,0,.265-.265v-1.972a.264.264,0,0,0-.265-.265h-4.208a.264.264,0,0,0-.265.265v1.972A.264.264,0,0,0,422.506,365.379Z",
    transform: "translate(19682.379 9191.83)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4153",
    "data-name": "Path 4153",
    d: "M526.106,488.579h4.208a.264.264,0,0,0,.265-.265v-1.972a.264.264,0,0,0-.265-.265h-4.208a.264.264,0,0,0-.265.265v1.972A.264.264,0,0,0,526.106,488.579Z",
    transform: "translate(19584.225 9075.104)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4154",
    "data-name": "Path 4154",
    d: "M526.106,365.379h4.208a.264.264,0,0,0,.265-.265v-1.972a.264.264,0,0,0-.265-.265h-4.208a.264.264,0,0,0-.265.265v1.972A.264.264,0,0,0,526.106,365.379Z",
    transform: "translate(19584.225 9191.83)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4155",
    "data-name": "Path 4155",
    d: "M332.64,251.612l.765,1.148a.321.321,0,0,0,.383.088l3.531-2.3a.321.321,0,0,0,.088-.383l-1.089-1.648a.287.287,0,0,0-.383-.088l-1.354.883a1.863,1.863,0,0,1-1.824,2.3h-.118Z",
    transform: "translate(19767.273 9300.302)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4156",
    "data-name": "Path 4156",
    d: "M578.117,426.983h1.471a.264.264,0,0,0,.265-.265v-1.972a.264.264,0,0,0-.265-.265h-1.471a.264.264,0,0,0-.265.265v1.972C577.823,426.865,577.97,426.983,578.117,426.983Z",
    transform: "translate(19534.949 9133.463)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4157",
    "data-name": "Path 4157",
    d: "M318.906,426.983h1.471a.264.264,0,0,0,.265-.265v-1.972a.264.264,0,0,0-.265-.265h-1.471a.264.264,0,0,0-.265.265v1.972A.264.264,0,0,0,318.906,426.983Z",
    transform: "translate(19780.537 9133.463)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4158",
    "data-name": "Path 4158",
    d: "M478.764,301.28h-4.179a.264.264,0,0,0-.265.265v1.972a.264.264,0,0,0,.265.265h4.208a.264.264,0,0,0,.265-.265v-1.972A.312.312,0,0,0,478.764,301.28Z",
    transform: "translate(19633.037 9250.191)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4159",
    "data-name": "Path 4159",
    d: "M577.36,301.546v1.972a.264.264,0,0,0,.265.265H579.1a.264.264,0,0,0,.265-.265v-1.972a.264.264,0,0,0-.265-.265h-1.471A.284.284,0,0,0,577.36,301.546Z",
    transform: "translate(19535.414 9250.19)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4160",
    "data-name": "Path 4160",
    d: "M97.534,160.691a1.167,1.167,0,0,0,1.059-.677,1.217,1.217,0,0,0-.559-1.589,6.717,6.717,0,0,1-1.883-1.471,6.944,6.944,0,0,1-.647-.971,4.713,4.713,0,0,0-1.707-1.942c-.647-.294-1.707-.677-1.707-.677a2.032,2.032,0,0,0-2.266.353,16.976,16.976,0,0,0-2.766,5.15,10.143,10.143,0,0,0-.206,5.3A9.318,9.318,0,0,1,87,165.782c-.647,1.324-2.413,5.238-2.472,5.414a1.4,1.4,0,0,0,.706,1.854,1.318,1.318,0,0,0,.588.118,1.463,1.463,0,0,0,1.295-.824c.029-.029,1.883-4.179,2.472-5.385a4.578,4.578,0,0,0,.177-2.5,13.326,13.326,0,0,1,1.56,2.354,29.973,29.973,0,0,1-.294,4.8,1.4,1.4,0,0,0,1.236,1.56h.177a1.4,1.4,0,0,0,1.383-1.236c.618-5.061.235-5.944.118-6.209a17.426,17.426,0,0,0-2.442-3.59,23.648,23.648,0,0,1,2.119-4.826,12.868,12.868,0,0,0,.795,1.148,8.388,8.388,0,0,0,2.707,2.089c.059.118.236.147.412.147Z",
    transform: "translate(20002.469 9390.516)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4161",
    "data-name": "Path 4161",
    d: "M219.054,83.288a2.658,2.658,0,0,0,3.443-1.324l-4.8-2.442a.877.877,0,0,0-.118.235,2.708,2.708,0,0,0,1.471,3.531Z",
    transform: "translate(19876.475 9460.298)",
    fill: "#e1d100"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4162",
    "data-name": "Path 4162",
    d: "M224.49,28.081l5.385,2.737a.318.318,0,0,0,.441-.147v-.029a.343.343,0,0,0-.147-.441l-.353-.206a2.868,2.868,0,0,0-.294-2.8l-.206.412a.3.3,0,0,1-.235.147.177.177,0,0,1-.118-.029.272.272,0,0,1-.118-.353l.383-.765a.247.247,0,0,0-.118-.324l-.824-.383a.247.247,0,0,0-.324.118l-.412.795a.3.3,0,0,1-.235.147.177.177,0,0,1-.118-.029.283.283,0,0,1-.118-.353l.235-.5a2.813,2.813,0,0,0-2.5,1.412.337.337,0,0,0-.324.589Z",
    transform: "translate(19869.891 9511.12)",
    fill: "#e1d100"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in_progress.8b389ed095bd410df5c93c2ae17beca8.svg";
export { ForwardRef as ReactComponent };